import { request } from 'shared/lib/request';

export const getLoginBanners = () => request.get('/login-banners/');
